/* eslint-disable no-restricted-syntax */
import { Product } from '../types/products'
import { BrandAndCluster } from '../types/brands'

export type FilterType = 'all' | 'shared' | 'unique'

type ProductCategory = {
	sharedUPCs: Set<string>
	uniqueUPCs: Set<string>
}

const getUPC = (product: Product): string => product.UPC

/**
 * It calculates which UPCs are shared and which are unique among compared clusters.
 */
export const calculateUPCCategories = (
	compareClusters: BrandAndCluster[],
): ProductCategory => {
	const [cluster1, cluster2] = compareClusters

	if (!cluster1 || !cluster2) {
		return { sharedUPCs: new Set(), uniqueUPCs: new Set() }
	}

	const UPCsSet1 = new Set(cluster1.cluster.products.map(getUPC))
	const UPCsSet2 = new Set(cluster2.cluster.products.map(getUPC))

	const sharedUPCs = new Set<string>()
	const uniqueUPCs = new Set<string>()

	UPCsSet1.forEach(UPC => {
		if (UPCsSet2.has(UPC)) {
			sharedUPCs.add(UPC)
		} else {
			uniqueUPCs.add(UPC)
		}
	})
	UPCsSet2.forEach(UPC => {
		if (!UPCsSet1.has(UPC)) {
			uniqueUPCs.add(UPC)
		}
	})

	return { sharedUPCs, uniqueUPCs }
}

/** @deprecated Use calculateUPCCategories. */
export const calculateSkuCodeCategories = calculateUPCCategories

/**
 * It filters products based on selected filter type.
 */
export const filterProducts = (
	products: Product[],
	filterType: FilterType,
	sharedUPCs: Set<string>,
	uniqueUPCs: Set<string>,
): Product[] => {
	if (filterType === 'all') {
		const shared = products.filter(p => sharedUPCs.has(getUPC(p)))
		const unique = products.filter(p => uniqueUPCs.has(getUPC(p)))
		return [...shared, ...unique]
	}

	if (filterType === 'shared') {
		return products.filter(p => sharedUPCs.has(getUPC(p)))
	}

	if (filterType === 'unique') {
		return products.filter(p => uniqueUPCs.has(getUPC(p)))
	}

	return products
}
